import { VStack, Text, Link } from "@chakra-ui/react";
import cities from '../cities.json';
import { useEffect, useState } from "react";

export default function Phone({ city, page }) {

    const [data, setData] = useState([]);
    const [ggg, setGGG] = useState('Москва');

    useEffect(() => {
        Object.values(cities).map(x => x.text === 'Московская область' && upd(x.cities));
        if (typeof (city) !== 'object') setGGG(city);
    }, []);

    function upd(x) {
        Object.values(x).map(x => setData(old => [...old, x]))
        setData(old => [...old, 'Москва'])
    };

    return <VStack>
        <Link isExternal href={`tel:${data.includes(ggg) ? '+79257096009' : '+79876543210'}`} _hover={{ textDecoration: 'none' }} ><Text color={page ? '' : 'white'} fontFamily={page ? 'Hero' : ''} mt={page ? '-10px' : ''} fontSize={page ? 20 : 17}>{data.includes(ggg) ? '+7 (925) 709-60-09' : '+7 (987) 654 32 10'}</Text></Link>
    </VStack>
}